/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Form } from "react-bootstrap";
import { UpdateElectricityAgreementPackageModalForm } from "components/ElectricityAgreements/models";
import { getLastMonthWithFirstDay, getLastMonthWithLastDay, getMarketPricePackageProductDescription } from "helpers";

interface UpdateElectricityAgreementInvoiceProductInfoFormProps {
    form: UpdateElectricityAgreementPackageModalForm;
    setForm: (form: UpdateElectricityAgreementPackageModalForm) => void;
}

export default function UpdateElectricityAgreementInvoiceProductInfoForm(
    { form, setForm } : UpdateElectricityAgreementInvoiceProductInfoFormProps
) {

    return (
            <>
              <div className="row">
                  <div className="col-12 col-md-6">
                      <Form.Label>Toote kirjeldus PDF-il</Form.Label>
                      <Form.Control
                          value={form.consumptionPackage?.pdfProductDescriptionOnInvoice}
                          onChange={(e) => setForm({
                                  ...form,
                                  consumptionPackage: {
                                      ...form.consumptionPackage,
                                      pdfProductDescriptionOnInvoice: e.target.value
                                  }
                              })
                          }
                          type="text"
                      />
                  </div>
              </div>
              <div className='text-break text-gray-700'>{form.consumptionPackage?.pdfProductDescriptionOnInvoice ?? (form.consumptionPackage?.marketPricePackage ? getMarketPricePackageProductDescription(form.consumptionPackage.nameEt) : "Elektrienergia universaalteenuse hinnaga")} ({getLastMonthWithFirstDay()} - {getLastMonthWithLastDay()}) mõõtepunktis <b>X</b> aadressiga <b>X</b></div>
              <div className="row mt-3">
                  <div className="col-12 col-md-6">
                      <Form.Label>Toote kirjeldus meritis</Form.Label>
                      <Form.Control
                          className='col-12 col-md-6'
                          value={form.consumptionPackage?.externalProductDescriptionOnInvoice}
                          onChange={(e) => setForm({
                                  ...form,
                                  consumptionPackage: {
                                      ...form.consumptionPackage,
                                      externalProductDescriptionOnInvoice: e.target.value
                                  }
                              })
                          }
                          maxLength={150}
                          type="text"
                      />
                  </div>
              </div>
              <div className='col-12 p-0 text-break text-gray-700'>{form.consumptionPackage?.externalProductDescriptionOnInvoice ?? (form.consumptionPackage?.marketPricePackage ? getMarketPricePackageProductDescription(form.consumptionPackage.nameEt) : "Elektri universaalteenus")} ({getLastMonthWithFirstDay()} - {getLastMonthWithLastDay()}) - (<b>X</b>) <b>X</b></div>
          </>
    );
}